import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Button, PdfViewer, View, ViewHeader } from '../../../../core/components/Index';
import { Appl } from '../../../../core/Appl';
import SpcViewModel from './SpcViewModel';
import { SpcSteps } from './SpcModels';
const PrintEstimate = observer(() => {

  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  vm.navigate = useNavigate();
  let {memberId, spcTypeSubId } = useParams();
  useAsyncEffect(async () => {
    vm.memberId = memberId!;
    await vm.downloadEstimate(spcTypeSubId as unknown as number);
  }, []);
  return (
    <>
      <View id="PrintEstimate" pageTitle="Estimate"
        showMenuBar={false}
      >
        <ViewHeader title={`${vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name} — Service Purchase Estimate`} description={vm.pageDescription} helpPageId="">
          <div className='my-2 md:my-0 space-y-2 sm:space-y-0 w-full flex flex-wrap lg:flex-nowrap'>
            <div className='w-1/2 sm:w-auto pl-1' ><Button  className='w-full'  label='Close' outlined rounded onClick={() => vm.navigate(`/spc/estimate/${vm.memberId}/${SpcSteps.Estimate}`)} /></div> 
          </div>
        </ViewHeader>
        {vm.afrFile && <PdfViewer data={vm.afrFile} />}
      </View >
    </>
  );
});
export default PrintEstimate;



